import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import socketIOClient from 'socket.io-client'
import Modal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { slugify } from './utils/slugify.js'
import { useTemplates } from '../hooks/useTemplate.js'
import PayloadComponent from './PayloadComponent.js'
import MessageComponent from './MessageComponent.js'
import { getQueryParam } from './utils/parse-query-params.js'

Modal.setAppElement('#root')

const UploadFile = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [payload, setPayload] = useState('')
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')
  const [errorResponse, setErrorResponse] = useState('')
  const [crmPhoneTest, setCrmPhoneTest] = useState('')

  /* Upload Status Informations*/
  const [template, setTemplate] = useState(null)
  const [uploadStatus, setUploadStatus] = useState('')

  /* Client Informations */
  const [codWeb, setCodweb] = useState(null)


  const { templates } = useTemplates(codWeb)

  const isStatusFinished = status === 'finished'
  const isPopupScreen = window.opener;

  console.log('isPopupScreen: ', isPopupScreen)

  const handleTemplateChange = (e) => {
    const selectedFile = e.target.value
    setTemplate(selectedFile)
  }

  const openOAuthPopup = (url) => {
    const popup = window.open(
      url,
      'oauth-login',
      'width=600,height=600,left=100,top=100'
    )

    if (!popup) {
      alert('Por favor, habilite popups para este site.')
      return
    }
  }

  const handleUpload = async () => {
    if (!template) {
      alert('Please select a template.')
      return
    }

    const jsonTemplate = JSON.parse(template)
    const jsonString = JSON.stringify(jsonTemplate, null, 2)
    const fileName = `${slugify(jsonTemplate.title)}.json`

    const jsonFile = new File(
      [jsonString],
      fileName,
      { type: "application/json" }
    )

    const formData = new FormData()
    formData.append('crm', jsonFile)
    formData.append('companyId', codWeb)

    try {
      const response = await axios.post(`${process.env.REACT_APP_URL_API}/api/v1/crm/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${process.env.REACT_APP_API_TOKEN}`
        },
      })
      if (response.status === 200) {

        const { url } = response.data

        console.log('-----> url: ', url)
        if (url) {
          // Abre OAuth em popup ao invés de redirecionar
          openOAuthPopup(url)
        }

        setUploadStatus('File uploaded successfully!')
      } else {
        setUploadStatus('Failed to upload file.')

        console.log('error')
      }
    } catch (error) {
      console.error('Error uploading file:', error)
      setUploadStatus('Error uploading file.')

      setStatus('error')
      console.log('error: ', error)
      setErrorResponse(error.response.data.msg)
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleOAuthFlowSuccessfully = (clientId) => {
    window.opener.postMessage({
      type: 'oauth-success',
      clientId: clientId
    }, '*')
    window.close()
  }

  const initTemplateTest = async (clientId, codWebFromUrl) => {
    try {
      await axios.post(`${process.env.REACT_APP_URL_API}/api/v1/crm/test`, {
        clientId,
        companyId: codWebFromUrl,
      })
    } catch (error) {
      setStatus('error')
      console.log('-----> Error:', error)
      console.log('TEST: ', error.response.data.msg)
      setErrorResponse(error.response.data.msg)
    }
  }

  const handlePopupMessage = useCallback(async (event) => {
    if (event.data.type === 'oauth-success' && event.data.clientId) {
      const clientId = event.data.clientId
      if (clientId && codWeb) await initTemplateTest(clientId, codWeb)
    }
  }, [codWeb])

  /* Params Initialization useEffect */
  useEffect(() => {
    if (isPopupScreen) return
    const codWebFromUrl = getQueryParam('codWeb')
    if (codWebFromUrl) setCodweb(codWebFromUrl)
  }, [codWeb, isPopupScreen])

  /* OAuth Popup Callback Handler useEffect */
  useEffect(() => {
    const clientId = getQueryParam('clientId')
    const isOAuthPopup = isPopupScreen && clientId
    if (isOAuthPopup) return handleOAuthFlowSuccessfully(clientId)

    window.addEventListener('message', handlePopupMessage)
    return () => {
      window.removeEventListener('message', handlePopupMessage)
    }
  }, [codWeb, handlePopupMessage, isPopupScreen])

  /* Socket.io useEffect */
  useEffect(() => {

    if (isPopupScreen) return

    const socket = socketIOClient(process.env.REACT_APP_URL_API)

    console.log('==============> codWeb: ', codWeb)

    if (codWeb)
      socket.emit('companySession', codWeb)

    socket.on('crm_upload', (data) => {
      console.log('Received data from server:', data)

      setStatus(data?.status)

      setMessage(data?.data?.msg)

      if (data?.data?.request) {
        setPayload(data.data.request, null, 2)
      }

      if (data?.data?.crmPhoneTest) {
        setCrmPhoneTest(data.data.crmPhoneTest)
      }
      setIsModalOpen(true)
    })

    return () => {
      socket.disconnect()
    }
  }, [codWeb, isPopupScreen])

  return (
    isPopupScreen
      ?
      <div>
        <h2>Esta é uma janela popup para autenticação OAuth.</h2>
        <p>Após a autenticação, esta janela será fechada automaticamente.</p>
      </div >
      : (
        <div className="centered">
          <select onChange={handleTemplateChange}>
            <option value="">-- SELECIONE UM TEMPLATE --</option>

            {templates.map((template, index) => (
              <option key={index} value={JSON.stringify(template)}>
                {template.title}
              </option>
            ))}
          </select>
          {template && <button onClick={handleUpload}>Integrar</button>}
          {uploadStatus && <p>{uploadStatus}</p>}

          <Modal
            isOpen={isModalOpen}
            contentLabel="Example Modal"
          >
            {/* Modal Title */}
            <div className="modal-title">
              {status === 'finished' && <h2>Template validado com sucesso</h2>}
              {status === 'error' && <h2>Template com erro no processo abaixo</h2>}
              {status === 'processing' && <h2>Testando template. Aguarde...</h2>}
            </div>

            {/* Error Messages*/}
            <div className="error-message">
              {status === 'error' && (
                <p>
                  {errorResponse}
                </p>
              )}
            </div>
            <div className="success-message">
              {status === 'finished' && (
                <p>
                  Verifique no seu CRM os dados inseridos para o contato de teste: {crmPhoneTest}
                </p>
              )}
            </div>

            {/* Icon Container*/}
            <div className="icon-container">
              {status === 'finished' &&
                <div className="checkmark-container">
                  <FontAwesomeIcon icon={faCheckCircle} size="5x" color="green" />
                </div>
              }
            </div>

            {/* Icon Container*/}
            {
              !isStatusFinished
              &&
              <>
                <MessageComponent title={message} />
                {payload && <PayloadComponent formattedJSON={payload} />}
              </>
            }
            <button className="close-button" onClick={handleCloseModal}>Fechar Modal</button>
          </Modal>
        </div>
      )

  )
}




export default UploadFile
